import React, { useState } from 'react';
import { UserContext } from './UserContext';

export const UserProvider = ({ children }) => {
  const [globalUser, setUser] = useState(null);
  const login = (userData) =>{
    setUser(userData);
  } 

  const updateUser = (newData) => {
    setUser((prev) => ({
      ...(prev || {}), 
      ...newData,      
    }));
  };

  return (
    <UserContext.Provider value={{ globalUser, updateUser, login }}>
      {children}
    </UserContext.Provider>
  );
};
